import { colors } from 'theme'

export const defaultThemeStyles = {
    'withShadow-background': colors.white,
    'withShadow-border': 'transparent',
    'withShadow-textMain': colors.blackLight,
    'withShadow-icon': colors.grey,
    'withShadow-shadow': `2px 3px 4px 0px rgba(0, 0, 0, 0.25)`,
    'none-background': colors.white,
    'none-border': 'transparent',
    'none-textMain': colors.blackLight,
    'none-icon': colors.grey,
    'none-shadow': `none`,
}
